import { render } from "./ScheduleRoute.vue?vue&type=template&id=3376ecf1&ts=true"
import script from "./ScheduleRoute.vue?vue&type=script&lang=ts"
export * from "./ScheduleRoute.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__